import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
//Animation
import { motion } from 'framer-motion';
import { pageAnimation, titleAnim, photoAnim } from '../animation';
//icons and imgs
import facebook from '../img/facebook.svg'
import instagram from '../img/instagram.svg'
import cr1 from '../img/cr1.jpg'
import cr2 from '../img/cr2.jpg'
import cr3 from '../img/cr3.jpg'
import cr4 from '../img/cr4.jpg'
//scroll top
import ScrollTop from '../components/ScrollTop';
//file
import cv from '../img/cv.pdf'

const ContactUs = () => {
  const history = useHistory();
  const activePath = history.location.pathname;
  return (
    <ContactStyle
      style={{ background: '#fff' }}
      variants={pageAnimation}
      exit="exit"
      initial="hidden"
      animate="show"
    >
      <ScrollTop />
      <Title>
        <Hide>
          <motion.h2 variants={titleAnim}>Get in touch.</motion.h2>
        </Hide>
        <motion.div transition={{ duration: 0.75 }} initial={{width:'0%'}} animate={{width: activePath === '/contact' ? '20%' : '0%'}} className="line1"></motion.div>
      </Title>
      <div>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <a href='https://www.facebook.com/abdlsamd.alkorashy'  target='_blank' rel="noopener noreferrer"><img src={facebook} alt="facebook" /></a>
            <a href='https://www.instagram.com/chefdoo0/' target='blank' rel="noopener noreferrer"><img src={instagram} alt="instagram" /></a>
            <a href={cv} download>cv</a>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <h2>Send us a message</h2>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <h2>abdelsamd3810@gmail.com</h2>
          </Social>
        </Hide>
      </div>
      <Certificates>

        <motion.div className="title">
        <Hide>
          <motion.h2 variants={titleAnim}>Certificates</motion.h2>
        </Hide>
        <motion.div transition={{ duration: 0.75 }} initial={{width:'0%'}} animate={{width: activePath === '/contact' ? '20%' : '0%'}} className="line2"></motion.div>
        </motion.div>

        <motion.div variants={photoAnim} className="imgs">
          <img src={cr1} alt="certificate" />
          <img src={cr2} alt="certificate" />
          <img src={cr3} alt="certificate" />
          <img src={cr4} alt="certificate" />
        </motion.div>
      </Certificates>
    </ContactStyle>
  );
};

const Hide = styled.div`
  overflow: hidden;
`;

const ContactStyle = styled(motion.div)`
  padding: 5rem 10rem;
  color: #353535;
  min-height: 90vh;
  overflow-x:hidden;

  .line1{
    height: 0.3rem;
  background: #23d997;
  width: 0%;
  position: absolute;
  bottom: -15%;
  left: 0.3%;
  }

  @media (max-width: 1200px) {
    padding: 2rem 1rem;
  }

`;
const Title = styled.div`
  margin-bottom: 4rem;
  position: relative;
  h2{
    color: black;
  }
  
  @media (max-width:450px){
    margin: 1.5rem 0;
    h2{
      font-size: 3rem;
    }
  }
`;
const Circle = styled.div`
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  background: #353535;
  @media (max-width: 1200px) {
    display: none;
  }
`;

const Social = styled(motion.div)`
  display: flex;
  align-items: center;
 margin: 1.2rem 0;
  a{
    margin-left: 3rem;
    cursor: pointer;
    :last-child{
      font-size: 1.5rem;
      color: cornflowerblue;
    }
  }
  img{
    width:3.5rem;
    transition: 0.5s all ease;
    &:hover{
      transform:rotateZ(-360deg) translateY(-5%);
    }
  }
 h2{
   margin-left: 3rem;
   font-size: 2.6rem;
 }

  @media (max-width: 1200px) {
    a{
      margin-left:0;
    }
    a:nth-child(3){
      margin-left: 3rem;
    }
    a:nth-child(4){
      margin-left: 3rem;
    }
    h2 {
      margin: 0rem ;
      font-size: 2.2rem;
    }
  }
  @media (max-width: 450px) {
    margin: 1rem 0;
    img{
      width:3rem;
    }
    h2 {
      font-size: 1.5rem;
    }
  } 
`;

const Certificates = styled.div`
  padding: 5rem 0;
  .title{
    position: relative;
  }
  .line2{
    height: 0.3rem;
  background: #23d997;
  width: 0%;
  position: absolute;
  bottom: 25%;
  left: 0.3%;
  }

  h2{
    color:black;
    margin: 4rem 0;
  }
  .imgs{
    display:grid;
    grid-template-columns: repeat( 4 ,1fr);
    grid-gap:20px;
    img{
      cursor: pointer;
      width:100%;
      height:100%;
      transition: 0.2s ease all;
      &:hover{
        transform: scale(1.5)
      }
    }
    @media (max-width:800px){
      grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    }
    @media (max-width:450px){
      img{
      &:hover{
        transform: scale(1.1)
      }
    }
    }
  }

  @media (max-width: 450px) {
    padding: 3.5rem 0;
    h2 {
      margin: 2rem 0 3rem 0;
      font-size: 3rem;
    }
  } 
`

export default ContactUs;
